var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftFlags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 578,
    viewBox: "0 0 77 578",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.2002 144.9H-212.3V434.1L76.2002 144.9Z",
    fill: "#F2F6FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-32.3004 180.9L3.89961 144.9L39.9996 180.9L76.1996 144.9V180.9L39.9996 217L3.89961 180.9L-32.3004 217L-68.4004 180.9V144.9L-32.3004 180.9Z",
    fill: "#6363A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89961 217L39.9996 253L76.1996 217V253L39.9996 289.1L3.89961 253L-32.3004 289.1L-68.4004 253V217L-32.3004 253L3.89961 217Z",
    fill: "#E96345"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-68.4004 433.2H76.1996V577.4H-68.4004V433.2Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4002 533.6C52.5002 533.6 55.0002 531.1 55.0002 528C55.0002 524.9 52.5002 522.4 49.4002 522.4C46.3002 522.4 43.7002 524.9 43.7002 528C43.7002 531.1 46.3002 533.6 49.4002 533.6Z",
    fill: "#FABD29"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6 533.6C29.7 533.6 32.3 531.1 32.3 528C32.3 524.9 29.7 522.4 26.6 522.4C23.5 522.4 21 524.9 21 528C21 531.1 23.5 533.6 26.6 533.6Z",
    fill: "#FABD29"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9002 533.6C7.00019 533.6 9.5002 531.1 9.5002 528C9.5002 524.9 7.00019 522.4 3.9002 522.4C0.800195 522.4 -1.7998 524.9 -1.7998 528C-1.7998 531.1 0.800195 533.6 3.9002 533.6Z",
    fill: "#FABD29"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4002 510.9C52.5002 510.9 55.0002 508.4 55.0002 505.3C55.0002 502.2 52.5002 499.7 49.4002 499.7C46.3002 499.7 43.7002 502.2 43.7002 505.3C43.7002 508.4 46.3002 510.9 49.4002 510.9Z",
    fill: "#FABD29"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6 510.9C29.7 510.9 32.3 508.4 32.3 505.3C32.3 502.2 29.7 499.7 26.6 499.7C23.5 499.7 21 502.2 21 505.3C21 508.4 23.5 510.9 26.6 510.9Z",
    fill: "#FABD29"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9002 510.9C7.00019 510.9 9.5002 508.4 9.5002 505.3C9.5002 502.2 7.00019 499.7 3.9002 499.7C0.800195 499.7 -1.7998 502.2 -1.7998 505.3C-1.7998 508.4 0.800195 510.9 3.9002 510.9Z",
    fill: "#FABD29"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4002 488.2C52.5002 488.2 55.0002 485.7 55.0002 482.6C55.0002 479.5 52.5002 477 49.4002 477C46.3002 477 43.7002 479.5 43.7002 482.6C43.7002 485.7 46.3002 488.2 49.4002 488.2Z",
    fill: "#FABD29"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6 488.2C29.7 488.2 32.3 485.7 32.3 482.6C32.3 479.5 29.7 477 26.6 477C23.5 477 21 479.5 21 482.6C21 485.7 23.5 488.2 26.6 488.2Z",
    fill: "#FABD29"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9002 488.2C7.00019 488.2 9.5002 485.7 9.5002 482.6C9.5002 479.5 7.00019 477 3.9002 477C0.800195 477 -1.7998 479.5 -1.7998 482.6C-1.7998 485.7 0.800195 488.2 3.9002 488.2Z",
    fill: "#FABD29"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4002 465.5C52.5002 465.5 55.0002 463 55.0002 459.9C55.0002 456.8 52.5002 454.3 49.4002 454.3C46.3002 454.3 43.7002 456.8 43.7002 459.9C43.7002 463 46.3002 465.5 49.4002 465.5Z",
    fill: "#FABD29"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6 465.5C29.7 465.5 32.3 463 32.3 459.9C32.3 456.8 29.7 454.3 26.6 454.3C23.5 454.3 21 456.8 21 459.9C21 463 23.5 465.5 26.6 465.5Z",
    fill: "#FABD29"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9002 465.5C7.00019 465.5 9.5002 463 9.5002 459.9C9.5002 456.8 7.00019 454.3 3.9002 454.3C0.800195 454.3 -1.7998 456.8 -1.7998 459.9C-1.7998 463 0.800195 465.5 3.9002 465.5Z",
    fill: "#FABD29"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M-68.4004 0.5H76.1996V144.7H-68.4004V0.5Z",
    fill: "#064DA1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90039 40.6001C20.9004 41.9001 34.5004 55.5001 35.9004 72.6001H36.0004C37.4004 55.5001 51.0004 41.9001 68.0004 40.6001V40.5001C51.0004 39.2001 37.4004 25.6001 36.0004 8.6001H35.9004C34.5004 25.6001 20.9004 39.2001 3.90039 40.5001V40.6001Z",
    fill: "#77B75A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M-60.2998 40.6001C-43.1998 41.9001 -29.5998 55.5001 -28.2998 72.6001H-28.0998C-26.7998 55.5001 -13.1998 41.9001 3.90019 40.6001V40.5001C-13.1998 39.2001 -26.7998 25.6001 -28.0998 8.6001H-28.2998C-29.5998 25.6001 -43.1998 39.2001 -60.2998 40.5001V40.6001Z",
    fill: "#77B75A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90039 104.6C20.9004 105.9 34.5004 119.5 35.9004 136.6H36.0004C37.4004 119.5 51.0004 105.9 68.0004 104.6V104.5C51.0004 103.2 37.4004 89.6001 36.0004 72.6001H35.9004C34.5004 89.6001 20.9004 103.2 3.90039 104.5V104.6Z",
    fill: "#77B75A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M-60.2998 104.6C-43.1998 105.9 -29.5998 119.5 -28.2998 136.6H-28.0998C-26.7998 119.5 -13.1998 105.9 3.90019 104.6V104.5C-13.1998 103.2 -26.7998 89.6001 -28.0998 72.6001H-28.2998C-29.5998 89.6001 -43.1998 103.2 -60.2998 104.5V104.6Z",
    fill: "#77B75A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M-67.2998 289.8V432.5H75.0002V289.8H-67.2998Z",
    fill: "#DCE4EF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M-27.5998 361.2C-26.3998 378 -12.9998 391.5 3.9002 392.8V392.9C-12.9998 394.2 -26.3998 407.7 -27.5998 424.5H-27.7998C-28.9998 407.7 -42.4998 394.2 -59.2998 392.9V392.8C-42.4998 391.5 -28.9998 378 -27.7998 361.2H-27.5998Z",
    fill: "#064DA1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M-27.5998 297.8C-26.3998 314.7 -12.9998 328.1 3.9002 329.4V329.6C-12.9998 330.9 -26.3998 344.3 -27.5998 361.2H-27.7998C-28.9998 344.3 -42.4998 330.9 -59.2998 329.6V329.4C-42.4998 328.1 -28.9998 314.7 -27.7998 297.8H-27.5998Z",
    fill: "#064DA1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5004 361.2C36.8004 378 50.2004 391.5 67.0004 392.8V392.9C50.2004 394.2 36.8004 407.7 35.5004 424.5H35.4004C34.1004 407.7 20.7004 394.2 3.90039 392.9V392.8C20.7004 391.5 34.1004 378 35.4004 361.2H35.5004Z",
    fill: "#064DA1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5004 297.8C36.8004 314.7 50.2004 328.1 67.0004 329.4V329.6C50.2004 330.9 36.8004 344.3 35.5004 361.2H35.4004C34.1004 344.3 20.7004 330.9 3.90039 329.6V329.4C20.7004 328.1 34.1004 314.7 35.4004 297.8H35.5004Z",
    fill: "#064DA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftFlags);
export default __webpack_public_path__ + "static/media/left_flags.ff0bcabe7aac9a3052f2bb1df43164e0.svg";
export { ForwardRef as ReactComponent };